import {
	column,
	Config,
	createComponent,
	datasourcestore,
	DataSourceStore,
	ListEventMap,
	Table
} from "@intermesh/goui";
import {jmapds} from "@intermesh/groupoffice-core";

import {t} from "./Translate";

export class FormBookTable extends Table<DataSourceStore> {
	constructor() {

		const store = datasourcestore({
			dataSource: jmapds("FormBook"),
			queryParams: {
				limit: 20,
				filter: {
				}
			},
			sort: [{property: "name", isAscending: true}]
		});

		const columns = [
			column({
				header: t("Name"),
				id:"name",
				resizable: true,
				sortable: true
			})
		];
		
		super(store, columns );

		this.rowSelectionConfig =  {
			multiSelect: true
		};

		this.headers = true;

	}
}

export const formbooktable = (config?: Config<FormBookTable>) => createComponent(new FormBookTable(), config);